!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e(require("react"), require("prop-types"), require("react-router-dom")) : "function" == typeof define && define.amd ? define(["react", "prop-types", "react-router-dom"], e) : "object" == typeof exports ? exports["react-breadcrumbs"] = e(require("react"), require("prop-types"), require("react-router-dom")) : t["react-breadcrumbs"] = e(t.React, t.PropTypes, t.ReactRouterDOM);
}(this, function (t, e, r) {
  return function (t) {
    function e(n) {
      if (r[n]) return r[n].exports;
      var o = r[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return t[n].call(o.exports, o, o.exports, e), o.l = !0, o.exports;
    }

    var r = {};
    return e.m = t, e.c = r, e.d = function (t, r, n) {
      e.o(t, r) || Object.defineProperty(t, r, {
        configurable: !1,
        enumerable: !0,
        get: n
      });
    }, e.n = function (t) {
      var r = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return e.d(r, "a", r), r;
    }, e.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, e.p = "", e(e.s = 12);
  }([function (t, e) {
    var r;

    r = function () {
      return this;
    }();

    try {
      r = r || Function("return this")() || (0, eval)("this");
    } catch (t) {
      "object" == typeof window && (r = window);
    }

    t.exports = r;
  }, function (e, r) {
    e.exports = t;
  }, function (t, r) {
    t.exports = e;
  }, function (t, e, r) {
    (function (e) {
      var r,
          n = e.crypto || e.msCrypto;

      if (n && n.getRandomValues) {
        var o = new Uint8Array(16);

        r = function r() {
          return n.getRandomValues(o), o;
        };
      }

      if (!r) {
        var i = new Array(16);

        r = function r() {
          for (var t, e = 0; e < 16; e++) {
            0 == (3 & e) && (t = 4294967296 * Math.random()), i[e] = t >>> ((3 & e) << 3) & 255;
          }

          return i;
        };
      }

      t.exports = r;
    }).call(e, r(0));
  }, function (t, e) {
    function r(t, e) {
      var r = e || 0,
          o = n;
      return o[t[r++]] + o[t[r++]] + o[t[r++]] + o[t[r++]] + "-" + o[t[r++]] + o[t[r++]] + "-" + o[t[r++]] + o[t[r++]] + "-" + o[t[r++]] + o[t[r++]] + "-" + o[t[r++]] + o[t[r++]] + o[t[r++]] + o[t[r++]] + o[t[r++]] + o[t[r++]];
    }

    for (var n = [], o = 0; o < 256; ++o) {
      n[o] = (o + 256).toString(16).substr(1);
    }

    t.exports = r;
  }, function (t, e) {
    t.exports = function (t) {
      return t.webpackPolyfill || (t.deprecate = function () {}, t.paths = [], t.children || (t.children = []), Object.defineProperty(t, "loaded", {
        enumerable: !0,
        get: function get() {
          return t.l;
        }
      }), Object.defineProperty(t, "id", {
        enumerable: !0,
        get: function get() {
          return t.i;
        }
      }), t.webpackPolyfill = 1), t;
    };
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      if (Array.isArray(t)) {
        for (var e = 0, r = Array(t.length); e < t.length; e++) {
          r[e] = t[e];
        }

        return r;
      }

      return Array.from(t);
    }

    r.d(e, "a", function () {
      return c;
    });

    var o = r(18),
        i = function i() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
          e = arguments[1];

      switch (e.type) {
        case "ADD_CRUMB":
          return [].concat(n(t), [e.payload]);

        case "UPDATE_CRUMB":
          return t.map(function (t) {
            return t.id === e.payload.id ? e.payload : t;
          });

        case "REMOVE_CRUMB":
          return t.filter(function (t) {
            return t.id !== e.payload.id;
          });

        default:
          return t;
      }
    },
        a = Object(o.a)(i);

    e.b = a;
    var c = a.dispatch;
  }, function (t, e, r) {
    "use strict";

    function n(t, e, r) {
      function i() {
        y === v && (y = v.slice());
      }

      function u() {
        return b;
      }

      function s(t) {
        if ("function" != typeof t) throw new Error("Expected listener to be a function.");
        var e = !0;
        return i(), y.push(t), function () {
          if (e) {
            e = !1, i();
            var r = y.indexOf(t);
            y.splice(r, 1);
          }
        };
      }

      function f(t) {
        if (!Object(o.a)(t)) throw new Error("Actions must be plain objects. Use custom middleware for async actions.");
        if (void 0 === t.type) throw new Error('Actions may not have an undefined "type" property. Have you misspelled a constant?');
        if (_) throw new Error("Reducers may not dispatch actions.");

        try {
          _ = !0, b = h(b, t);
        } finally {
          _ = !1;
        }

        for (var e = v = y, r = 0; r < e.length; r++) {
          (0, e[r])();
        }

        return t;
      }

      function l(t) {
        if ("function" != typeof t) throw new Error("Expected the nextReducer to be a function.");
        h = t, f({
          type: c.INIT
        });
      }

      function p() {
        var t,
            e = s;
        return t = {
          subscribe: function subscribe(t) {
            function r() {
              t.next && t.next(u());
            }

            if ("object" != typeof t) throw new TypeError("Expected the observer to be an object.");
            return r(), {
              unsubscribe: e(r)
            };
          }
        }, t[a.a] = function () {
          return this;
        }, t;
      }

      var d;

      if ("function" == typeof e && void 0 === r && (r = e, e = void 0), void 0 !== r) {
        if ("function" != typeof r) throw new Error("Expected the enhancer to be a function.");
        return r(n)(t, e);
      }

      if ("function" != typeof t) throw new Error("Expected the reducer to be a function.");

      var h = t,
          b = e,
          v = [],
          y = v,
          _ = !1;

      return f({
        type: c.INIT
      }), d = {
        dispatch: f,
        subscribe: s,
        getState: u,
        replaceReducer: l
      }, d[a.a] = p, d;
    }

    r.d(e, "a", function () {
      return c;
    }), e.b = n;
    var o = r(8),
        i = r(27),
        a = r.n(i),
        c = {
      INIT: "@@redux/INIT"
    };
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      if (!Object(a.a)(t) || Object(o.a)(t) != c) return !1;
      var e = Object(i.a)(t);
      if (null === e) return !0;
      var r = l.call(e, "constructor") && e.constructor;
      return "function" == typeof r && r instanceof r && f.call(r) == p;
    }

    var o = r(19),
        i = r(24),
        a = r(26),
        c = "[object Object]",
        u = Function.prototype,
        s = Object.prototype,
        f = u.toString,
        l = s.hasOwnProperty,
        p = f.call(Object);
    e.a = n;
  }, function (t, e, r) {
    "use strict";

    var n = r(20),
        o = n.a.Symbol;
    e.a = o;
  }, function (t, e, r) {
    "use strict";
  }, function (t, e, r) {
    "use strict";

    function n() {
      for (var t = arguments.length, e = Array(t), r = 0; r < t; r++) {
        e[r] = arguments[r];
      }

      return 0 === e.length ? function (t) {
        return t;
      } : 1 === e.length ? e[0] : e.reduce(function (t, e) {
        return function () {
          return t(e.apply(void 0, arguments));
        };
      });
    }

    e.a = n;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var n = r(13);
    r.d(e, "Breadcrumb", function () {
      return n.a;
    });
    var o = r(33);
    r.d(e, "Breadcrumbs", function () {
      return o.a;
    });
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function o(t, e) {
      if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !e || "object" != typeof e && "function" != typeof e ? t : e;
    }

    function i(t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }

    var a = r(1),
        c = r.n(a),
        u = r(2),
        s = r.n(u),
        f = r(14),
        l = r.n(f),
        p = r(17),
        d = r.n(p),
        h = r(6),
        b = Object.assign || function (t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = arguments[e];

        for (var n in r) {
          Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
        }
      }

      return t;
    },
        v = function () {
      function t(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      return function (e, r, n) {
        return r && t(e.prototype, r), n && t(e, n), e;
      };
    }(),
        y = function (t) {
      function e() {
        var t, r, i, a;
        n(this, e);

        for (var c = arguments.length, u = Array(c), s = 0; s < c; s++) {
          u[s] = arguments[s];
        }

        return r = i = o(this, (t = e.__proto__ || Object.getPrototypeOf(e)).call.apply(t, [this].concat(u))), i.state = {
          id: l.a.v4()
        }, a = r, o(i, a);
      }

      return i(e, t), v(e, [{
        key: "render",
        value: function value() {
          return this.props.children;
        }
      }, {
        key: "componentDidMount",
        value: function value() {
          var t = this.props,
              e = t.data;
          t.hidden || this._dispatch("ADD_CRUMB", e);
        }
      }, {
        key: "componentWillReceiveProps",
        value: function value(t) {
          var e = t.data,
              r = t.hidden;
          d()(e, this.props.data) || this._dispatch("UPDATE_CRUMB", e), r && !this.props.hidden ? this._dispatch("REMOVE_CRUMB", e) : !r && this.props.hidden && this._dispatch("ADD_CRUMB", e);
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this._dispatch("REMOVE_CRUMB", this.props.data);
        }
      }, {
        key: "_dispatch",
        value: function value(t, e) {
          var r = this.state.id;
          Object(h.a)({
            type: t,
            payload: b({
              id: r
            }, e)
          });
        }
      }]), e;
    }(c.a.Component);

    y.propTypes = {
      data: s.a.object.isRequired,
      hidden: s.a.bool,
      children: s.a.element
    }, y.defaultProps = {
      hidden: !1,
      children: null
    }, e.a = y;
  }, function (t, e, r) {
    var n = r(15),
        o = r(16),
        i = o;
    i.v1 = n, i.v4 = o, t.exports = i;
  }, function (t, e, r) {
    function n(t, e, r) {
      var n = e && r || 0,
          o = e || [];
      t = t || {};
      var a = void 0 !== t.clockseq ? t.clockseq : u,
          l = void 0 !== t.msecs ? t.msecs : new Date().getTime(),
          p = void 0 !== t.nsecs ? t.nsecs : f + 1,
          d = l - s + (p - f) / 1e4;
      if (d < 0 && void 0 === t.clockseq && (a = a + 1 & 16383), (d < 0 || l > s) && void 0 === t.nsecs && (p = 0), p >= 1e4) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
      s = l, f = p, u = a, l += 122192928e5;
      var h = (1e4 * (268435455 & l) + p) % 4294967296;
      o[n++] = h >>> 24 & 255, o[n++] = h >>> 16 & 255, o[n++] = h >>> 8 & 255, o[n++] = 255 & h;
      var b = l / 4294967296 * 1e4 & 268435455;
      o[n++] = b >>> 8 & 255, o[n++] = 255 & b, o[n++] = b >>> 24 & 15 | 16, o[n++] = b >>> 16 & 255, o[n++] = a >>> 8 | 128, o[n++] = 255 & a;

      for (var v = t.node || c, y = 0; y < 6; ++y) {
        o[n + y] = v[y];
      }

      return e || i(o);
    }

    var o = r(3),
        i = r(4),
        a = o(),
        c = [1 | a[0], a[1], a[2], a[3], a[4], a[5]],
        u = 16383 & (a[6] << 8 | a[7]),
        s = 0,
        f = 0;
    t.exports = n;
  }, function (t, e, r) {
    function n(t, e, r) {
      var n = e && r || 0;
      "string" == typeof t && (e = "binary" == t ? new Array(16) : null, t = null), t = t || {};
      var a = t.random || (t.rng || o)();
      if (a[6] = 15 & a[6] | 64, a[8] = 63 & a[8] | 128, e) for (var c = 0; c < 16; ++c) {
        e[n + c] = a[c];
      }
      return e || i(a);
    }

    var o = r(3),
        i = r(4);
    t.exports = n;
  }, function (t, e, r) {
    (function (t, r) {
      function n(t, e) {
        for (var r = -1, n = null == t ? 0 : t.length, o = 0, i = []; ++r < n;) {
          var a = t[r];
          e(a, r, t) && (i[o++] = a);
        }

        return i;
      }

      function o(t, e) {
        for (var r = -1, n = e.length, o = t.length; ++r < n;) {
          t[o + r] = e[r];
        }

        return t;
      }

      function i(t, e) {
        for (var r = -1, n = null == t ? 0 : t.length; ++r < n;) {
          if (e(t[r], r, t)) return !0;
        }

        return !1;
      }

      function a(t, e) {
        for (var r = -1, n = Array(t); ++r < t;) {
          n[r] = e(r);
        }

        return n;
      }

      function c(t, e) {
        return t.has(e);
      }

      function u(t, e) {
        return null == t ? void 0 : t[e];
      }

      function s(t) {
        var e = -1,
            r = Array(t.size);
        return t.forEach(function (t, n) {
          r[++e] = [n, t];
        }), r;
      }

      function f(t) {
        var e = -1,
            r = Array(t.size);
        return t.forEach(function (t) {
          r[++e] = t;
        }), r;
      }

      function l(t) {
        var e = -1,
            r = null == t ? 0 : t.length;

        for (this.clear(); ++e < r;) {
          var n = t[e];
          this.set(n[0], n[1]);
        }
      }

      function p() {
        this.__data__ = Ee ? Ee(null) : {}, this.size = 0;
      }

      function d(t) {
        var e = this.has(t) && delete this.__data__[t];
        return this.size -= e ? 1 : 0, e;
      }

      function h(t) {
        var e = this.__data__;

        if (Ee) {
          var r = e[t];
          return r === _t ? void 0 : r;
        }

        return ae.call(e, t) ? e[t] : void 0;
      }

      function b(t) {
        var e = this.__data__;
        return Ee ? void 0 !== e[t] : ae.call(e, t);
      }

      function v(t, e) {
        var r = this.__data__;
        return this.size += this.has(t) ? 0 : 1, r[t] = Ee && void 0 === e ? _t : e, this;
      }

      function y(t) {
        var e = -1,
            r = null == t ? 0 : t.length;

        for (this.clear(); ++e < r;) {
          var n = t[e];
          this.set(n[0], n[1]);
        }
      }

      function _() {
        this.__data__ = [], this.size = 0;
      }

      function j(t) {
        var e = this.__data__,
            r = I(e, t);
        return !(r < 0) && (r == e.length - 1 ? e.pop() : he.call(e, r, 1), --this.size, !0);
      }

      function m(t) {
        var e = this.__data__,
            r = I(e, t);
        return r < 0 ? void 0 : e[r][1];
      }

      function g(t) {
        return I(this.__data__, t) > -1;
      }

      function w(t, e) {
        var r = this.__data__,
            n = I(r, t);
        return n < 0 ? (++this.size, r.push([t, e])) : r[n][1] = e, this;
      }

      function O(t) {
        var e = -1,
            r = null == t ? 0 : t.length;

        for (this.clear(); ++e < r;) {
          var n = t[e];
          this.set(n[0], n[1]);
        }
      }

      function E() {
        this.size = 0, this.__data__ = {
          hash: new l(),
          map: new (me || y)(),
          string: new l()
        };
      }

      function x(t) {
        var e = Y(this, t).delete(t);
        return this.size -= e ? 1 : 0, e;
      }

      function A(t) {
        return Y(this, t).get(t);
      }

      function P(t) {
        return Y(this, t).has(t);
      }

      function k(t, e) {
        var r = Y(this, t),
            n = r.size;
        return r.set(t, e), this.size += r.size == n ? 0 : 1, this;
      }

      function M(t) {
        var e = -1,
            r = null == t ? 0 : t.length;

        for (this.__data__ = new O(); ++e < r;) {
          this.add(t[e]);
        }
      }

      function R(t) {
        return this.__data__.set(t, _t), this;
      }

      function z(t) {
        return this.__data__.has(t);
      }

      function T(t) {
        var e = this.__data__ = new y(t);
        this.size = e.size;
      }

      function S() {
        this.__data__ = new y(), this.size = 0;
      }

      function U(t) {
        var e = this.__data__,
            r = e.delete(t);
        return this.size = e.size, r;
      }

      function C(t) {
        return this.__data__.get(t);
      }

      function N(t) {
        return this.__data__.has(t);
      }

      function B(t, e) {
        var r = this.__data__;

        if (r instanceof y) {
          var n = r.__data__;
          if (!me || n.length < yt - 1) return n.push([t, e]), this.size = ++r.size, this;
          r = this.__data__ = new O(n);
        }

        return r.set(t, e), this.size = r.size, this;
      }

      function D(t, e) {
        var r = Ce(t),
            n = !r && Ue(t),
            o = !r && !n && Ne(t),
            i = !r && !n && !o && Be(t),
            c = r || n || o || i,
            u = c ? a(t.length, String) : [],
            s = u.length;

        for (var f in t) {
          !e && !ae.call(t, f) || c && ("length" == f || o && ("offset" == f || "parent" == f) || i && ("buffer" == f || "byteLength" == f || "byteOffset" == f) || et(f, s)) || u.push(f);
        }

        return u;
      }

      function I(t, e) {
        for (var r = t.length; r--;) {
          if (ct(t[r][0], e)) return r;
        }

        return -1;
      }

      function q(t, e, r) {
        var n = e(t);
        return Ce(t) ? n : o(n, r(t));
      }

      function F(t) {
        return null == t ? void 0 === t ? It : Tt : be && be in Object(t) ? tt(t) : it(t);
      }

      function W(t) {
        return dt(t) && F(t) == wt;
      }

      function V(t, e, r, n, o) {
        return t === e || (null == t || null == e || !dt(t) && !dt(e) ? t !== t && e !== e : $(t, e, r, n, V, o));
      }

      function $(t, e, r, n, o, i) {
        var a = Ce(t),
            c = Ce(e),
            u = a ? Ot : Se(t),
            s = c ? Ot : Se(e);
        u = u == wt ? St : u, s = s == wt ? St : s;
        var f = u == St,
            l = s == St,
            p = u == s;

        if (p && Ne(t)) {
          if (!Ne(e)) return !1;
          a = !0, f = !1;
        }

        if (p && !f) return i || (i = new T()), a || Be(t) ? J(t, e, r, n, o, i) : K(t, e, u, r, n, o, i);

        if (!(r & jt)) {
          var d = f && ae.call(t, "__wrapped__"),
              h = l && ae.call(e, "__wrapped__");

          if (d || h) {
            var b = d ? t.value() : t,
                v = h ? e.value() : e;
            return i || (i = new T()), o(b, v, r, n, i);
          }
        }

        return !!p && (i || (i = new T()), Q(t, e, r, n, o, i));
      }

      function L(t) {
        return !(!pt(t) || nt(t)) && (ft(t) ? se : Vt).test(at(t));
      }

      function G(t) {
        return dt(t) && lt(t.length) && !!Lt[F(t)];
      }

      function H(t) {
        if (!ot(t)) return _e(t);
        var e = [];

        for (var r in Object(t)) {
          ae.call(t, r) && "constructor" != r && e.push(r);
        }

        return e;
      }

      function J(t, e, r, n, o, a) {
        var u = r & jt,
            s = t.length,
            f = e.length;
        if (s != f && !(u && f > s)) return !1;
        var l = a.get(t);
        if (l && a.get(e)) return l == e;
        var p = -1,
            d = !0,
            h = r & mt ? new M() : void 0;

        for (a.set(t, e), a.set(e, t); ++p < s;) {
          var b = t[p],
              v = e[p];
          if (n) var y = u ? n(v, b, p, e, t, a) : n(b, v, p, t, e, a);

          if (void 0 !== y) {
            if (y) continue;
            d = !1;
            break;
          }

          if (h) {
            if (!i(e, function (t, e) {
              if (!c(h, e) && (b === t || o(b, t, r, n, a))) return h.push(e);
            })) {
              d = !1;
              break;
            }
          } else if (b !== v && !o(b, v, r, n, a)) {
            d = !1;
            break;
          }
        }

        return a.delete(t), a.delete(e), d;
      }

      function K(t, e, r, n, o, i, a) {
        switch (r) {
          case Ft:
            if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset) return !1;
            t = t.buffer, e = e.buffer;

          case qt:
            return !(t.byteLength != e.byteLength || !i(new pe(t), new pe(e)));

          case xt:
          case At:
          case zt:
            return ct(+t, +e);

          case Pt:
            return t.name == e.name && t.message == e.message;

          case Ct:
          case Bt:
            return t == e + "";

          case Rt:
            var c = s;

          case Nt:
            var u = n & jt;
            if (c || (c = f), t.size != e.size && !u) return !1;
            var l = a.get(t);
            if (l) return l == e;
            n |= mt, a.set(t, e);
            var p = J(c(t), c(e), n, o, i, a);
            return a.delete(t), p;

          case Dt:
            if (ze) return ze.call(t) == ze.call(e);
        }

        return !1;
      }

      function Q(t, e, r, n, o, i) {
        var a = r & jt,
            c = X(t),
            u = c.length;
        if (u != X(e).length && !a) return !1;

        for (var s = u; s--;) {
          var f = c[s];
          if (!(a ? f in e : ae.call(e, f))) return !1;
        }

        var l = i.get(t);
        if (l && i.get(e)) return l == e;
        var p = !0;
        i.set(t, e), i.set(e, t);

        for (var d = a; ++s < u;) {
          f = c[s];
          var h = t[f],
              b = e[f];
          if (n) var v = a ? n(b, h, f, e, t, i) : n(h, b, f, t, e, i);

          if (!(void 0 === v ? h === b || o(h, b, r, n, i) : v)) {
            p = !1;
            break;
          }

          d || (d = "constructor" == f);
        }

        if (p && !d) {
          var y = t.constructor,
              _ = e.constructor;
          y != _ && "constructor" in t && "constructor" in e && !("function" == typeof y && y instanceof y && "function" == typeof _ && _ instanceof _) && (p = !1);
        }

        return i.delete(t), i.delete(e), p;
      }

      function X(t) {
        return q(t, ht, Te);
      }

      function Y(t, e) {
        var r = t.__data__;
        return rt(e) ? r["string" == typeof e ? "string" : "hash"] : r.map;
      }

      function Z(t, e) {
        var r = u(t, e);
        return L(r) ? r : void 0;
      }

      function tt(t) {
        var e = ae.call(t, be),
            r = t[be];

        try {
          t[be] = void 0;
          var n = !0;
        } catch (t) {}

        var o = ue.call(t);
        return n && (e ? t[be] = r : delete t[be]), o;
      }

      function et(t, e) {
        return !!(e = null == e ? gt : e) && ("number" == typeof t || $t.test(t)) && t > -1 && t % 1 == 0 && t < e;
      }

      function rt(t) {
        var e = typeof t;
        return "string" == e || "number" == e || "symbol" == e || "boolean" == e ? "__proto__" !== t : null === t;
      }

      function nt(t) {
        return !!ce && ce in t;
      }

      function ot(t) {
        var e = t && t.constructor;
        return t === ("function" == typeof e && e.prototype || ne);
      }

      function it(t) {
        return ue.call(t);
      }

      function at(t) {
        if (null != t) {
          try {
            return ie.call(t);
          } catch (t) {}

          try {
            return t + "";
          } catch (t) {}
        }

        return "";
      }

      function ct(t, e) {
        return t === e || t !== t && e !== e;
      }

      function ut(t) {
        return null != t && lt(t.length) && !ft(t);
      }

      function st(t, e) {
        return V(t, e);
      }

      function ft(t) {
        if (!pt(t)) return !1;
        var e = F(t);
        return e == kt || e == Mt || e == Et || e == Ut;
      }

      function lt(t) {
        return "number" == typeof t && t > -1 && t % 1 == 0 && t <= gt;
      }

      function pt(t) {
        var e = typeof t;
        return null != t && ("object" == e || "function" == e);
      }

      function dt(t) {
        return null != t && "object" == typeof t;
      }

      function ht(t) {
        return ut(t) ? D(t) : H(t);
      }

      function bt() {
        return [];
      }

      function vt() {
        return !1;
      }

      var yt = 200,
          _t = "__lodash_hash_undefined__",
          jt = 1,
          mt = 2,
          gt = 9007199254740991,
          wt = "[object Arguments]",
          Ot = "[object Array]",
          Et = "[object AsyncFunction]",
          xt = "[object Boolean]",
          At = "[object Date]",
          Pt = "[object Error]",
          kt = "[object Function]",
          Mt = "[object GeneratorFunction]",
          Rt = "[object Map]",
          zt = "[object Number]",
          Tt = "[object Null]",
          St = "[object Object]",
          Ut = "[object Proxy]",
          Ct = "[object RegExp]",
          Nt = "[object Set]",
          Bt = "[object String]",
          Dt = "[object Symbol]",
          It = "[object Undefined]",
          qt = "[object ArrayBuffer]",
          Ft = "[object DataView]",
          Wt = /[\\^$.*+?()[\]{}|]/g,
          Vt = /^\[object .+?Constructor\]$/,
          $t = /^(?:0|[1-9]\d*)$/,
          Lt = {};
      Lt["[object Float32Array]"] = Lt["[object Float64Array]"] = Lt["[object Int8Array]"] = Lt["[object Int16Array]"] = Lt["[object Int32Array]"] = Lt["[object Uint8Array]"] = Lt["[object Uint8ClampedArray]"] = Lt["[object Uint16Array]"] = Lt["[object Uint32Array]"] = !0, Lt[wt] = Lt[Ot] = Lt[qt] = Lt[xt] = Lt[Ft] = Lt[At] = Lt[Pt] = Lt[kt] = Lt[Rt] = Lt[zt] = Lt[St] = Lt[Ct] = Lt[Nt] = Lt[Bt] = Lt["[object WeakMap]"] = !1;

      var Gt = "object" == typeof t && t && t.Object === Object && t,
          Ht = "object" == typeof self && self && self.Object === Object && self,
          Jt = Gt || Ht || Function("return this")(),
          Kt = "object" == typeof e && e && !e.nodeType && e,
          Qt = Kt && "object" == typeof r && r && !r.nodeType && r,
          Xt = Qt && Qt.exports === Kt,
          Yt = Xt && Gt.process,
          Zt = function () {
        try {
          return Yt && Yt.binding && Yt.binding("util");
        } catch (t) {}
      }(),
          te = Zt && Zt.isTypedArray,
          ee = Array.prototype,
          re = Function.prototype,
          ne = Object.prototype,
          oe = Jt["__core-js_shared__"],
          ie = re.toString,
          ae = ne.hasOwnProperty,
          ce = function () {
        var t = /[^.]+$/.exec(oe && oe.keys && oe.keys.IE_PROTO || "");
        return t ? "Symbol(src)_1." + t : "";
      }(),
          ue = ne.toString,
          se = RegExp("^" + ie.call(ae).replace(Wt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
          fe = Xt ? Jt.Buffer : void 0,
          le = Jt.Symbol,
          pe = Jt.Uint8Array,
          de = ne.propertyIsEnumerable,
          he = ee.splice,
          be = le ? le.toStringTag : void 0,
          ve = Object.getOwnPropertySymbols,
          ye = fe ? fe.isBuffer : void 0,
          _e = function (t, e) {
        return function (r) {
          return t(e(r));
        };
      }(Object.keys, Object),
          je = Z(Jt, "DataView"),
          me = Z(Jt, "Map"),
          ge = Z(Jt, "Promise"),
          we = Z(Jt, "Set"),
          Oe = Z(Jt, "WeakMap"),
          Ee = Z(Object, "create"),
          xe = at(je),
          Ae = at(me),
          Pe = at(ge),
          ke = at(we),
          Me = at(Oe),
          Re = le ? le.prototype : void 0,
          ze = Re ? Re.valueOf : void 0;

      l.prototype.clear = p, l.prototype.delete = d, l.prototype.get = h, l.prototype.has = b, l.prototype.set = v, y.prototype.clear = _, y.prototype.delete = j, y.prototype.get = m, y.prototype.has = g, y.prototype.set = w, O.prototype.clear = E, O.prototype.delete = x, O.prototype.get = A, O.prototype.has = P, O.prototype.set = k, M.prototype.add = M.prototype.push = R, M.prototype.has = z, T.prototype.clear = S, T.prototype.delete = U, T.prototype.get = C, T.prototype.has = N, T.prototype.set = B;
      var Te = ve ? function (t) {
        return null == t ? [] : (t = Object(t), n(ve(t), function (e) {
          return de.call(t, e);
        }));
      } : bt,
          Se = F;
      (je && Se(new je(new ArrayBuffer(1))) != Ft || me && Se(new me()) != Rt || ge && "[object Promise]" != Se(ge.resolve()) || we && Se(new we()) != Nt || Oe && "[object WeakMap]" != Se(new Oe())) && (Se = function Se(t) {
        var e = F(t),
            r = e == St ? t.constructor : void 0,
            n = r ? at(r) : "";
        if (n) switch (n) {
          case xe:
            return Ft;

          case Ae:
            return Rt;

          case Pe:
            return "[object Promise]";

          case ke:
            return Nt;

          case Me:
            return "[object WeakMap]";
        }
        return e;
      });
      var Ue = W(function () {
        return arguments;
      }()) ? W : function (t) {
        return dt(t) && ae.call(t, "callee") && !de.call(t, "callee");
      },
          Ce = Array.isArray,
          Ne = ye || vt,
          Be = te ? function (t) {
        return function (e) {
          return t(e);
        };
      }(te) : G;
      r.exports = st;
    }).call(e, r(0), r(5)(t));
  }, function (t, e, r) {
    "use strict";

    var n = r(7);
    r(30), r(31), r(32), r(11), r(10);
    r.d(e, "a", function () {
      return n.b;
    });
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      return null == t ? void 0 === t ? u : c : s && s in Object(t) ? Object(i.a)(t) : Object(a.a)(t);
    }

    var o = r(9),
        i = r(22),
        a = r(23),
        c = "[object Null]",
        u = "[object Undefined]",
        s = o.a ? o.a.toStringTag : void 0;
    e.a = n;
  }, function (t, e, r) {
    "use strict";

    var n = r(21),
        o = "object" == typeof self && self && self.Object === Object && self,
        i = n.a || o || Function("return this")();
    e.a = i;
  }, function (t, e, r) {
    "use strict";

    (function (t) {
      var r = "object" == typeof t && t && t.Object === Object && t;
      e.a = r;
    }).call(e, r(0));
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      var e = a.call(t, u),
          r = t[u];

      try {
        t[u] = void 0;
        var n = !0;
      } catch (t) {}

      var o = c.call(t);
      return n && (e ? t[u] = r : delete t[u]), o;
    }

    var o = r(9),
        i = Object.prototype,
        a = i.hasOwnProperty,
        c = i.toString,
        u = o.a ? o.a.toStringTag : void 0;
    e.a = n;
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      return i.call(t);
    }

    var o = Object.prototype,
        i = o.toString;
    e.a = n;
  }, function (t, e, r) {
    "use strict";

    var n = r(25),
        o = Object(n.a)(Object.getPrototypeOf, Object);
    e.a = o;
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      return function (r) {
        return t(e(r));
      };
    }

    e.a = n;
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      return null != t && "object" == typeof t;
    }

    e.a = n;
  }, function (t, e, r) {
    t.exports = r(28);
  }, function (t, e, r) {
    "use strict";

    (function (t, n) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });

      var o,
          i = r(29),
          a = function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }(i);

      o = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== t ? t : n;
      var c = (0, a.default)(o);
      e.default = c;
    }).call(e, r(0), r(5)(t));
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      var e,
          r = t.Symbol;
      return "function" == typeof r ? r.observable ? e = r.observable : (e = r("observable"), r.observable = e) : e = "@@observable", e;
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n;
  }, function (t, e, r) {
    "use strict";

    r(7), r(8), r(10);
  }, function (t, e, r) {
    "use strict";
  }, function (t, e, r) {
    "use strict";

    r(11), Object.assign;
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function o(t, e) {
      if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !e || "object" != typeof e && "function" != typeof e ? t : e;
    }

    function i(t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }

    var a = r(1),
        c = r.n(a),
        u = r(2),
        s = r.n(u),
        f = r(34),
        l = (r.n(f), r(6)),
        p = function () {
      function t(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      return function (e, r, n) {
        return r && t(e.prototype, r), n && t(e, n), e;
      };
    }(),
        d = "breadcrumbs",
        h = function (t) {
      function e() {
        var t, r, i, a;
        n(this, e);

        for (var c = arguments.length, u = Array(c), s = 0; s < c; s++) {
          u[s] = arguments[s];
        }

        return r = i = o(this, (t = e.__proto__ || Object.getPrototypeOf(e)).call.apply(t, [this].concat(u))), i._unsubscribe = null, a = r, o(i, a);
      }

      return i(e, t), p(e, [{
        key: "render",
        value: function value() {
          var t = this,
              e = this.props,
              r = e.className,
              n = e.hidden,
              o = e.wrapper,
              i = e.setCrumbs,
              a = n ? d + "--hidden" : "",
              u = l.b.getState();
          return u = u.sort(function (t, e) {
            return t.pathname.length - e.pathname.length;
          }), i && (u = i(u)), c.a.createElement("div", {
            className: r
          }, c.a.createElement(o, {
            className: d + " " + a
          }, c.a.createElement("div", {
            className: d + "__inner"
          }, u.map(function (e, r) {
            return c.a.createElement("span", {
              key: e.id,
              className: d + "__section"
            }, c.a.createElement(f.NavLink, {
              exact: !0,
              className: d + "__crumb",
              activeClassName: d + "__crumb--active",
              to: {
                pathname: e.pathname,
                search: e.search,
                state: e.state
              }
            }, e.title), r < u.length - 1 ? c.a.createElement("span", {
              className: d + "__separator"
            }, t.props.separator) : null);
          }))), this.props.children);
        }
      }, {
        key: "componentWillMount",
        value: function value() {
          var t = this;
          this._unsubscribe = l.b.subscribe(function () {
            t.forceUpdate();
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this._unsubscribe();
        }
      }]), e;
    }(c.a.Component);

    h.propTypes = {
      className: s.a.string,
      hidden: s.a.bool,
      separator: s.a.node,
      setCrumbs: s.a.func,
      wrapper: s.a.oneOfType([s.a.func, s.a.instanceOf(c.a.Component)]),
      children: s.a.oneOfType([s.a.node, s.a.arrayOf(s.a.node)])
    }, h.defaultProps = {
      className: "",
      hidden: !1,
      separator: ">",
      setCrumbs: void 0,
      wrapper: function wrapper(t) {
        return c.a.createElement("nav", t, t.children);
      }
    }, e.a = h;
  }, function (t, e) {
    t.exports = r;
  }]);
});